import { render, staticRenderFns } from "./ListPlanSegments.vue?vue&type=template&id=48991bdd"
import script from "./ListPlanSegments.vue?vue&type=script&lang=js"
export * from "./ListPlanSegments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports